/** UI strings: key = Bahasa Melayu text. Generated from the key list (scripts/i18n-keys.mjs). */
export const EN: Record<string, string> = {
  "(pilih 1)": "(choose 1)",
  "(sehingga {date})": "(until {date})",
  "1 kredit = 1 kertas soalan yang dijana. Kertas yang gagal dijana, JomBelajar dan muat turun semula PDF tidak ditolak.": "1 credit = 1 generated question paper. Failed generations, JomBelajar and re-downloading PDFs are free.",
  "10 soalan daripada unit ini. Jawapan terus disemak.": "10 questions from this unit. Answers are checked instantly.",
  "100 pembeli pertama": "First 100 buyers",
  "60 saat. Berapa banyak yang anda boleh?": "60 seconds. How many can you get?",
  "AI sedang menulis dan menyemak soalan. Ini boleh ambil sehingga 1–2 minit.": "The AI is writing and checking the questions. This can take up to 1–2 minutes.",
  "AI sedang menulis set penuh dan menyemaknya. Ini boleh ambil 2–5 minit.": "The AI is writing the full set and checking it. This can take 2–5 minutes.",
  "AI tidak lulus semakan automatik. Cuba lagi atau kurangkan SP.": "The AI output failed the automatic check. Try again or choose fewer learning standards.",
  "AI tidak lulus semakan automatik. Cuba lagi atau kurangkan topik.": "The AI output failed the automatic check. Try again or choose fewer topics.",
  "Adakah jawapan ini betul? Jawab sebanyak mungkin dalam 60 saat!": "Is this answer right? Answer as many as you can in 60 seconds!",
  "Affiliate": "Affiliate",
  "Akan datang": "Coming soon",
  "Log keluar": "Log out",
  "Akaun": "Account",
  "Akaun bank disimpan.": "Bank account saved.",
  "Akaun bank untuk bayaran": "Bank account for payouts",
  "Akaun ini sudah mempunyai lesen.": "This account already has a licence.",
  "Akses semua modul": "Access to every module",
  "Aktifkan lesen": "Activate licence",
  "Aktifkan lesen saya": "Activate my licence",
  "Anda dapat RM10 setiap kali": "You earn RM10 every time",
  "Anda dapat {a} (pembeli RM69) / {b} (pembeli RM79)": "You earn {a} (RM69 buyers) / {b} (RM79 buyers)",
  "Anda layak jadi affiliate": "You can become an affiliate",
  "Anda sudah ada permintaan bayaran yang belum selesai.": "You already have a payout request in progress.",
  "Anda tiada akses.": "You don't have access.",
  "BM & BI: Kertas 1 Pemahaman + Kertas 2 Penulisan": "BM & English: Paper 1 Comprehension + Paper 2 Writing",
  "Baca jarum jam dan pilih waktu yang betul.": "Read the clock hands and pick the right time.",
  "Baca jarum jam dan pilih waktunya.": "Read the clock and pick the time.",
  "Susunan bahagian mengikut subjek · aras rendah:sederhana:tinggi = 5:3:2": "Sections follow the subject format · easy:medium:hard = 5:3:2",
  "Bahasa Arab": "Arabic",
  "Bahasa Cina": "Chinese",
  "Bahasa Inggeris": "English",
  "Bahasa Melayu": "Malay",
  "Bahasa Tamil": "Tamil",
  "Bahasa kertas": "Paper language",
  "Baki belum cukup minimum pengeluaran.": "Your balance is below the minimum withdrawal.",
  "Baki boleh dikeluarkan": "Available to withdraw",
  "Baki boleh dikeluarkan {amount}. Minimum pengeluaran {min}.": "Available to withdraw: {amount}. Minimum withdrawal is {min}.",
  "Baki kertas AI": "AI papers left",
  "Bank / e-wallet": "Bank / e-wallet",
  "Batal": "Cancel",
  "Bayar": "Pay",
  "Bayar harga barang dengan tepat. Tekan syiling dan wang kertas, kemudian tekan Bayar.": "Pay the exact price. Tap coins and notes, then tap Pay.",
  "Bayar harga dengan syiling dan wang kertas.": "Pay the price with coins and notes.",
  "Bayar kepada {name} jumlah tepat:": "Pay {name} this exact amount:",
  "Bayar melalui DuitNow QR.": "Pay with DuitNow QR.",
  "Bayar sekali, guna selamanya": "Pay once, use forever",
  "Bayaran": "Payouts",
  "Bayaran belum disahkan.": "Payment not confirmed yet.",
  "Bayaran disahkan": "Payment confirmed",
  "Bayaran diterima untuk semakan. Kredit akan ditambah selepas disahkan.": "Payment received for review. Credits are added once it is confirmed.",
  "Pembayaran dalam talian tidak tersedia buat masa ini. Sila cuba lagi sebentar nanti.": "Online payment is unavailable right now. Please try again shortly.",
  "Bayaran tidak dapat disahkan": "Payment could not be confirmed",
  "Belajar Lebih Bijak Bersama JomCerdik": "Learn Smarter with JomCerdik",
  "Belajar sambil bermain. Setiap permainan dikira dalam kemajuan anda.": "Learn while you play. Every game counts towards your progress.",
  "Beli JomCerdik Lifetime": "Buy JomCerdik Lifetime",
  "Beli sekarang": "Buy now",
  "Belum ada jualan. Kongsi link anda di WhatsApp, Telegram atau Facebook.": "No sales yet. Share your link on WhatsApp, Telegram or Facebook.",
  "Belum ada kertas.": "No papers yet.",
  "Berapa bahagian pizza yang ada pepperoni? Pilih pecahan yang betul.": "How much of the pizza has pepperoni? Pick the right fraction.",
  "Berapa pecahan berlorek? (bentuk termudah)": "What fraction is shaded? (simplest form)",
  "Berapa pecahan pizza yang berlorek merah?": "What fraction of the pizza is shaded red?",
  "Betul": "True",
  "Betul atau Salah Kilat": "True or False Blitz",
  "Betul!": "Correct!",
  "Betul! Laju!": "Correct! Fast!",
  "Bilangan soalan: {n}": "Number of questions: {n}",
  "Buat pesanan baharu": "Place a new order",
  "Ciri ini untuk pemegang lesen.": "This feature is for licence holders.",
  "Contoh": "Example",
  "Cuba lagi": "Try again",
  "Cuba lagi. Anda pasti boleh!": "Try again. You can do it!",
  "Cuba lagi. Baca semula nota dan jawab sekali lagi.": "Try again. Read the notes once more and answer again.",
  "DSKP ({n} soalan)": "DSKP ({n} questions)",
  "Dapatkan lesen": "Get a licence",
  "Dapatkan link affiliate saya": "Get my affiliate link",
  "Dasar Privasi": "Privacy Policy",
  "Data DSKP sedang dimuatkan ke sistem. Cuba lagi sebentar lagi.": "DSKP data is being loaded. Please try again shortly.",
  "Dibatalkan (refund)": "Cancelled (refund)",
  "Dibayar": "Paid",
  "Diluluskan": "Approved",
  "Diminta": "Requested",
  "Disalin ✓": "Copied ✓",
  "Ditolak": "Rejected",
  "Dokumen undang-undang ini dalam Bahasa Melayu. Versi Bahasa Melayu ialah rujukan rasmi.": "This legal document is in Malay. The Malay version is the official reference.",
  "Duit anda": "Your money",
  "Early Bird (100 terawal)": "Early Bird (first 100)",
  "Early Bird 2 (pembeli 101–200)": "Early Bird 2 (buyers 101–200)",
  "Emel": "Email",
  "Emel tidak sah.": "Invalid email.",
  "Faham! Seterusnya →": "Got it! Next →",
  "Faham! ✔": "Got it! ✔",
  "Fail terlalu besar. Maksimum 5 MB.": "File is too large. Maximum 5 MB.",
  "Format UASA": "UASA format",
  "Format UASA (lama)": "UASA format (old)",
  "Format kertas tidak dijumpai.": "Paper format not found.",
  "Fungsi ini sedang dibina (Fasa {phase}). Tiada data dipaparkan sehingga ia disambungkan ke sistem sebenar.": "This feature is being built (Phase {phase}). No data is shown until it is connected to the live system.",
  "Gambar atau PDF (maksimum 5 MB). Invois diemel selepas bayaran disahkan.": "Image or PDF (max 5 MB). The invoice is emailed once payment is confirmed.",
  "Gambar atau PDF resit DuitNow / bank (maksimum 5 MB). Invois rasmi akan diemel selepas bayaran disahkan.": "Image or PDF of your DuitNow / bank receipt (max 5 MB). The official invoice is emailed once payment is confirmed.",
  "Geografi": "Geography",
  "Habis": "Sold out",
  "Had penjanaan dicapai. Kertas lama masih boleh dimuat turun.": "Generation limit reached. Earlier papers can still be downloaded.",
  "Halaman tidak dijumpai": "Page not found",
  "Hampir habis!": "Almost out!",
  "Hantar": "Submit",
  "Hantar pautan": "Send link",
  "Harga": "Price",
  "Harga awal untuk pembeli terawal": "Launch prices for the earliest buyers",
  "Harga biasa": "Standard price",
  "Harga biasa selepas itu": "Standard price after that",
  "Harga {p1} dan {p2} hanya untuk pembelian terus di sini. Hanya 200 pembeli awal boleh menjadi affiliate: rakan anda beli pada {p3}, dan anda dapat {c1} (jika anda beli {p1}) atau {c2} (jika anda beli {p2}) bagi setiap jualan.": "The {p1} and {p2} prices are only for direct purchases here. Only the first 200 buyers can become affiliates: your friends buy at {p3}, and you earn {c1} (if you bought at {p1}) or {c2} (if you bought at {p2}) for every sale.",
  "Harga {price} + {sen} sen kod padanan.": "Price {price} + {sen} sen matching code.",
  "Hebat! Teruskan usaha.": "Great! Keep it up.",
  "Ikut DSKP": "By DSKP",
  "Imbas & bayar": "Scan & pay",
  "Itu sebenarnya betul!": "That was actually right!",
  "Jam Ajaib": "Magic Clock",
  "Jam analog": "Analogue clock",
  "Jana kertas": "Generate paper",
  "Jana set soalan": "Generate question set",
  "Jawab betul untuk melompat ke batu seterusnya. Sampai ke istana sebelum nyawa habis!": "Answer correctly to hop to the next stone. Reach the castle before your lives run out!",
  "Jawab betul untuk sampai ke istana.": "Answer correctly to reach the castle.",
  "Jawapan betul: {x}": "Correct answer: {x}",
  "Jawapan: ": "Answer: ",
  "Jenis": "Type",
  "Jom belajar hari ini!": "Let's learn today!",
  "Jom guna JomCerdik — nota, kuiz dan kertas latihan ikut DSKP untuk anak-anak. Daftar di sini: {link}": "Try JomCerdik — DSKP-aligned notes, quizzes and practice papers for kids. Sign up here: {link}",
  "JomBelajar untuk pemegang lesen JomCerdik.": "JomBelajar is for JomCerdik licence holders.",
  "Jualan lesen": "Licence sales",
  "Jumlah": "Amount",
  "Jumlah perlu dibayar (tepat)": "Amount to pay (exact)",
  "KBAT": "HOTS",
  "Kad tertutup": "Face-down card",
  "Kami akan hantar pautan log masuk ke emel anda. Tiada kata laluan.": "We'll email you a sign-in link. No password needed.",
  "Kami tidak menjumpai bayaran yang sepadan. Hubungi kami dengan kod rujukan dan bukti bayaran.": "We couldn't find a matching payment. Contact us with your reference code and proof of payment.",
  "Kandungan sedang disediakan": "Content is being prepared",
  "Ke laman utama": "Go to home",
  "Ke nota": "To the notes",
  "Kedai Wang": "Money Shop",
  "Keluarkan duit": "Withdraw money",
  "Keluarkan {amount}": "Withdraw {amount}",
  "Keluarkan {amount} ke {bank} {acc} ({holder})?": "Withdraw {amount} to {bank} {acc} ({holder})?",
  "Kembali": "Back",
  "Kembali ke laman utama": "Back to home",
  "Kertas": "Paper",
  "Kertas 1": "Paper 1",
  "Kertas 1 - Pemahaman": "Paper 1 - Comprehension",
  "Kertas 2 - Penulisan": "Paper 2 - Writing",
  "Kertas AI": "AI papers",
  "Kertas AI anda sudah habis.": "You've used all your AI papers.",
  "Kertas dan skema jawapan": "Papers and answer schemes",
  "Kertas saya": "My papers",
  "Kertas siap! Muat turun di senarai 'Kertas saya'.": "Paper ready! Download it from 'My papers'.",
  "Kertas soalan": "Question paper",
  "Kertas {n}": "Paper {n}",
  "Kod": "Code",
  "Kod dan huraian SP diambil terus daripada dokumen rasmi DSKP.": "Learning standard codes and descriptions come straight from the official DSKP documents.",
  "Kod referral: {code}": "Referral code: {code}",
  "Komisen anda: {amount} setiap jualan lesen + RM10 setiap topup pelanggan.": "Your commission: {amount} per licence sale + RM10 per customer top-up.",
  "Komisen terkini": "Latest commissions",
  "Kongsi di WhatsApp": "Share on WhatsApp",
  "Kongsi link anda. Dapat komisen setiap jualan lesen dan setiap kali pelanggan anda tambah kredit.": "Share your link. Earn a commission on every licence sale and every time your customers top up credits.",
  "Kredit AI anda sudah habis. Tambah kredit di halaman Kredit untuk menjana lagi.": "You're out of AI credits. Top up on the Credits page to generate more.",
  "Kredit AI datang bersama lesen.": "AI credits come with the licence.",
  "Kredit lesen": "Licence credits",
  "Kuiz dijawab": "Quizzes taken",
  "Kuiz terbaik": "Best quiz",
  "Kurang {x}.": "{x} short.",
  "Laman utama": "Home",
  "Latihan ({n} soalan)": "Practice ({n} questions)",
  "Latihan ikut DSKP": "DSKP practice",
  "Latihan mengikut format UASA": "Practice in the UASA format",
  "Lesen": "Licence",
  "Lesen akan diikat pada emel ini.": "The licence will be tied to this email.",
  "Lesen lifetime anda kini aktif. Selamat belajar!": "Your lifetime licence is now active. Happy learning!",
  "Lihat JomBelajar": "See JomBelajar",
  "Lihat penjana": "See the generator",
  "Lihat resit": "View receipt",
  "Lihat semua": "See all",
  "Link affiliate anda": "Your affiliate link",
  "Log masuk": "Sign in",
  "Log masuk dengan emel yang digunakan semasa membeli.": "Sign in with the email you used to buy.",
  "Log masuk dengan emel yang sama digunakan semasa membeli untuk mengaktifkan lesen.": "Sign in with the same email you used to buy to activate the licence.",
  "Log masuk sebagai {email}.": "Signed in as {email}.",
  "Log masuk untuk mula belajar.": "Sign in to start learning.",
  "Main": "Play",
  "Main lagi": "Play again",
  "Masih dijana (set penuh ambil 2–5 minit). Anda boleh tinggalkan halaman ini.": "Still generating (a full set takes 2–5 minutes). You can leave this page.",
  "Masih dijana. Anda boleh tinggalkan halaman ini; kertas akan muncul dalam senarai.": "Still generating. You can leave this page; the paper will appear in the list.",
  "Matematik": "Mathematics",
  "Memuatkan DSKP…": "Loading DSKP…",
  "Memuatkan…": "Loading…",
  "Mengesahkan pautan…": "Checking the link…",
  "Menu": "Menu",
  "Minimum keluar {min} · pindahan bank": "Minimum withdrawal {min} · bank transfer",
  "Mudah": "Easy",
  "Muka depan, kotak pemeriksa, rajah": "Cover page, examiner boxes, diagrams",
  "Mula belajar": "Start learning",
  "Mula kuiz": "Start quiz",
  "Mula — semua unit": "Start — all units",
  "Mula!": "Start!",
  "Nama pembayar (seperti dalam akaun)": "Payer name (as in the account)",
  "Nama pemegang akaun": "Account holder name",
  "No. akaun": "Account number",
  "No. rujukan transaksi bank / e-wallet": "Bank / e-wallet transaction reference",
  "Nota dan kuiz ikut DSKP dan KSSR.": "Notes and quizzes aligned with the DSKP and KSSR.",
  "Nota penting": "Key notes",
  "Nota, latihan dan kuiz": "Notes, practice and quizzes",
  "Nyawa: {n}": "Lives: {n}",
  "PDF Kertas + Skema": "Paper + answer scheme PDFs",
  "PDF tidak dapat dibina untuk kertas ini. Sila laporkan kepada admin.": "The PDF couldn't be built for this paper. Please report it to the admin.",
  "Padan Kad": "Card Match",
  "Pautan log masuk tidak sah atau sudah tamat.": "The sign-in link is invalid or has expired.",
  "Pautan pengaktifan lesen telah dihantar ke {email}. Semak inbox, Spam dan Promosi.": "The licence activation link has been sent to {email}. Check your inbox, Spam and Promotions.",
  "Pautan pengaktifan sudah digunakan.": "The activation link has already been used.",
  "Pautan pengaktifan sudah tamat. Hubungi kami untuk pautan baharu.": "The activation link has expired. Contact us for a new one.",
  "Pautan pengaktifan tidak lengkap. Buka semula pautan dari emel anda.": "The activation link is incomplete. Open the link from your email again.",
  "Pautan pengaktifan tidak sah.": "Invalid activation link.",
  "Pecahkan belon dengan jawapan yang betul untuk terbangkan roket ke bulan!": "Pop the balloon with the right answer to fly the rocket to the moon!",
  "Pecahkan belon jawapan betul, terbangkan roket!": "Pop the right balloon, launch the rocket!",
  "Pelajaran dipelajari": "Lessons learned",
  "Pelanggan": "Customer",
  "Pelanggan anda topup RM50": "Your customer tops up RM50",
  "Pelanggan bayar {price}": "Customer pays {price}",
  "Pelarasan admin": "Admin adjustment",
  "Pelawat link": "Link visitors",
  "Pembeli ke-101 hingga 200": "Buyers 101 to 200",
  "Pendidikan Islam": "Islamic Education",
  "Pendidikan Jasmani": "Physical Education",
  "Pendidikan Kesihatan": "Health Education",
  "Pendidikan Moral": "Moral Education",
  "Pendidikan Muzik": "Music Education",
  "Pendidikan Seni Visual": "Visual Arts Education",
  "Penerima: {name}. Tulis {ref} dalam ruangan rujukan jika app bank anda membenarkan.": "Recipient: {name}. Write {ref} in the reference field if your banking app allows it.",
  "Pengeluaran {amount} (diminta {date}) sedang diproses. Resit akan diemel kepada anda.": "Your {amount} withdrawal (requested {date}) is being processed. The receipt will be emailed to you.",
  "Pengembaraan Soalan": "Question Quest",
  "Penjana Kertas": "Paper Generator",
  "Penjana UASA": "UASA Generator",
  "Penjana kertas sedang sibuk. Cuba lagi kemudian.": "The paper generator is busy. Please try again later.",
  "Penjana kertas untuk pemegang lesen.": "The paper generator is for licence holders.",
  "Penjanaan gagal.": "Generation failed.",
  "Perkhidmatan AI tidak dapat dihubungi. Kredit anda tidak ditolak.": "The AI service couldn't be reached. Your credits were not deducted.",
  "Tahun 1–3": "Years 1–3",
  "Tahun 4–6": "Years 4–6",
  "Harga dan pembelian": "Pricing and purchase",
  "Tebus kod": "Redeem code",
  "Permainan": "Games",
  "Permainan dimainkan": "Games played",
  "Permainan lain": "Other games",
  "Permainan memori: padankan soalan dan jawapan.": "Memory game: match questions with answers.",
  "Permintaan {amount} dihantar. Anda akan terima emel bersama resit sebaik sahaja duit dipindahkan.": "Request for {amount} sent. You'll get an email with the receipt as soon as the money is transferred.",
  "Pesanan ini sudah diproses.": "This order has already been processed.",
  "Pesanan ini tamat kerana tiada bayaran direkodkan. Jika anda sudah bayar, hubungi kami dengan kod rujukan ini.": "This order expired because no payment was recorded. If you have paid, contact us with this reference code.",
  "Pesanan tidak dijumpai. Semak kod rujukan dan emel.": "Order not found. Check the reference code and email.",
  "Pesanan {ref}": "Order {ref}",
  "Pilih sifir": "Choose times tables",
  "Pilih subjek": "Choose a subject",
  "Pilih tahun anda": "Choose your year",
  "Pilih unit dan SP": "Choose units and learning standards",
  "Pizza Pecahan": "Fraction Pizza",
  "Pizza dengan {k} daripada {n} potong berlorek": "Pizza with {k} of {n} slices shaded",
  "Polisi Pembatalan & Refund": "Cancellation & Refund Policy",
  "Polisi Refund": "Refund Policy",
  "Privasi": "Privacy",
  "Program affiliate terbuka kepada 200 pembeli awal (RM69 / RM79) yang lesennya aktif.": "The affiliate programme is open to the first 200 buyers (RM69 / RM79) with an active licence.",
  "Program akan dibuka kepada pengguna lain melalui promosi akan datang.": "The programme will open to other users in an upcoming promotion.",
  "Pukul berapa?": "What time is it?",
  "Ralat rangkaian. Cuba lagi.": "Network error. Please try again.",
  "Ralat sistem. Kredit anda tidak ditolak.": "System error. Your credits were not deducted.",
  "Ralat tidak dijangka. Cuba lagi.": "Unexpected error. Please try again.",
  "Reka Bentuk dan Teknologi": "Design and Technology",
  "Resit / screenshot bayaran": "Payment receipt / screenshot",
  "Resit mesti gambar (JPG/PNG/WEBP) atau PDF.": "The receipt must be an image (JPG/PNG/WEBP) or a PDF.",
  "Resit tidak dapat dibuka. Cuba lagi.": "The receipt couldn't be opened. Please try again.",
  "Rujukan bank ini sudah digunakan untuk pesanan lain.": "This bank reference has already been used for another order.",
  "Rujukan: {ref}": "Reference: {ref}",
  "Sahkan emel anda dahulu.": "Please verify your email first.",
  "Sains": "Science",
  "Salah": "False",
  "Salin link": "Copy link",
  "Satu lesen, semua modul, akses seumur hidup.": "One licence, every module, lifetime access.",
  "Satu pautan, satu akaun, sekali guna.": "One link, one account, single use.",
  "Saya bersetuju dengan": "I agree to the",
  "Saya sudah bayar": "I have paid",
  "Sedang dijana…": "Generating…",
  "Sederhana": "Medium",
  "Pengeluaran diproses setiap {n} hari (2 minggu sekali)": "Payouts are processed every {n} days (every 2 weeks)",
  "Pengeluaran dibayar setiap 2 minggu sekali. Permohonan dibayar pada pusingan seterusnya.": "Payouts are paid every 2 weeks. Requests are paid in the next round.",
  "Sedia dikeluarkan": "Ready to withdraw",
  "Sedia untuk kuiz?": "Ready for the quiz?",
  "Sejarah": "History",
  "Sejarah kredit": "Credit history",
  "Selesai": "Done",
  "Semak emel anda. Pautan sah selama 15 minit. Log masuk di peranti baharu akan menamatkan sesi lama.": "Check your email. The link is valid for 15 minutes. Signing in on a new device ends the old session.",
  "Semakan jawapan": "Answer review",
  "Semua subjek": "All subjects",
  "Semua subjek · Tahun 1–6": "All subjects · Year 1–6",
  "Set format UASA": "UASA-format set",
  "Set soalan format UASA": "UASA-format question set",
  "Set soalan format UASA untuk semua subjek Tahun 1–6, atau latihan ikut DSKP.": "UASA-format question sets for every subject, Year 1–6, or DSKP practice.",
  "Seterusnya": "Next",
  "Sifir Roket": "Rocket Times Tables",
  "Sila lampirkan resit atau screenshot bayaran.": "Please attach the payment receipt or screenshot.",
  "Sila log masuk.": "Please sign in.",
  "Sila semak maklumat yang dimasukkan.": "Please check the details you entered.",
  "Sila tunggu…": "Please wait…",
  "Simpan akaun bank": "Save bank account",
  "Simpan akaun bank anda dahulu.": "Save your bank account first.",
  "Simpan akaun bank anda di atas dahulu.": "Save your bank account above first.",
  "Skema jawapan": "Answer scheme",
  "Skema jawapan berasingan": "Separate answer scheme",
  "Slot Early Bird anda disimpan selama {time} lagi.": "Your Early Bird slot is held for another {time}.",
  "Slot Early Bird pesanan ini telah dilepaskan.": "The Early Bird slot for this order has been released.",
  "Soalan ditanda dengan kod SP": "Questions tagged with learning standard codes",
  "Soalan {i} daripada {n}": "Question {i} of {n}",
  "Standard": "Standard",
  "Standard Pembelajaran (DSKP)": "Learning Standards (DSKP)",
  "Standard Pembelajaran ({n}/{max} dipilih)": "Learning standards ({n}/{max} chosen)",
  "Status": "Status",
  "Subjek": "Subject",
  "Sudah bayar?": "Already paid?",
  "Sudah dibayar": "Paid out",
  "Tahap": "Level",
  "Tahun": "Year",
  "Tahun / Tingkatan": "Year / Form",
  "Tahun 1 hingga 6": "Year 1 to 6",
  "Tahun {n}": "Year {n}",
  "Tambah kertas": "Add papers",
  "Tambah kredit": "Top up credits",
  "Tambah {n} kertas dengan {price}.": "Add {n} papers for {price}.",
  "Tambah {n} kertas — {price}": "Add {n} papers — {price}",
  "Tanpa had": "Unlimited",
  "Tarikh": "Date",
  "Teka pecahan pizza yang berlorek.": "Guess the shaded fraction of the pizza.",
  "Tekan duit di bawah untuk bayar.": "Tap the money below to pay.",
  "Tempoh pesanan tamat": "Order expired",
  "Tempoh pesanan telah tamat. Sila buat pesanan baharu.": "The order has expired. Please place a new order.",
  "Tempoh simpanan tamat. Jika anda sudah bayar, hantar rujukan sekarang.": "The hold has expired. If you have paid, submit your reference now.",
  "Terbalikkan dua kad. Padankan setiap soalan (biru) dengan jawapannya (kuning).": "Flip two cards. Match each question (blue) with its answer (yellow).",
  "Terima kasih! Bayaran anda sedang disemak. Pautan pengaktifan akan dihantar ke {email} sebaik sahaja disahkan (biasanya dalam masa beberapa jam pada waktu bekerja). Halaman ini dikemas kini secara automatik. Emel kadang-kadang masuk ke folder Spam atau Promosi, jadi sila semak di situ juga.": "Thank you! Your payment is being checked. The activation link will be sent to {email} as soon as it is confirmed (usually within a few hours during working hours). This page updates automatically. The email sometimes lands in your Spam or Promotions folder, so please check there too.",
  "Terima kasih! Kredit akan ditambah sebaik sahaja bayaran disahkan (biasanya dalam hari yang sama).": "Thank you! Credits will be added as soon as the payment is confirmed (usually the same day).",
  "Terlalu banyak cubaan. Cuba lagi sebentar.": "Too many attempts. Please try again shortly.",
  "Terlalu ramai sedang membuat bayaran. Cuba lagi dalam beberapa minit.": "Too many people are checking out right now. Please try again in a few minutes.",
  "Terlebih {x}. Cuba kira semula.": "{x} too much. Try counting again.",
  "Terma": "Terms",
  "Terma & Syarat": "Terms & Conditions",
  "Tertahan": "On hold",
  "Tertahan {n} hari (tempoh refund)": "Held for {n} days (refund period)",
  "Teruskan ke bayaran": "Continue to payment",
  "Tiada rekod lagi.": "No records yet.",
  "Tiada soalan untuk pilihan ini lagi.": "No questions for this choice yet.",
  "Tiada subjek untuk tahun ini lagi.": "No subjects for this year yet.",
  "Tidak dijawab": "Not answered",
  "Tinggal {n} slot": "{n} slots left",
  "Tingkatan {n}": "Form {n}",
  "Topup kredit": "Credit top-up",
  "Topup pelanggan": "Customer top-ups",
  "Tukar": "Change",
  "Tukar bahasa": "Change language",
  "Tukar ke tema cerah": "Switch to light theme",
  "Tukar ke tema gelap": "Switch to dark theme",
  "Tutup": "Close",
  "UASA, nota, kuiz dan PDF dalam satu platform.": "UASA, notes, quizzes and PDFs in one platform.",
  "Unit": "Units",
  "Unit yang diuji ({n}/{max})": "Units tested ({n}/{max})",
  "Utama": "Main",
  "Utama (mudah alih)": "Main (mobile)",
  "Versi": "Version",
  "Waktu pagi. Apakah waktu dalam sistem 24 jam?": "Morning. What is the time in the 24-hour system?",
  "Waktu petang/malam. Apakah waktu dalam sistem 24 jam?": "Afternoon/evening. What is the time in the 24-hour system?",
  "atau pilih satu unit": "or choose one unit",
  "dan": "and",
  "dwibahasa": "bilingual",
  "isian": "fill-in",
  "padanan": "matching",
  "tanda ✓/×": "tick / cross",
  "jawapan pendek": "short answer",
  "kertas": "papers",
  "kertas lagi boleh dijana": "more papers you can generate",
  "objektif": "objective",
  "pelajaran": "lessons",
  "pelajaran selesai": "lessons done",
  "rujukan {ref}": "reference {ref}",
  "sen": "sen",
  "struktur": "structured",
  "susun ayat": "sentence building",
  "tanpa had": "unlimited",
  "unit": "units",
  "unit sedia": "units ready",
  "untuk melihat kredit anda.": "to see your credits.",
  "untuk melihat link affiliate anda.": "to see your affiliate link.",
  "untuk menjana kertas.": "to generate papers.",
  "versi English": "English version",
  "{amount} lagi masih tertahan ({n} hari selepas jualan) dan akan masuk ke baki secara automatik.": "{amount} more is still on hold ({n} days after each sale) and will move to your balance automatically.",
  "{a} kumpulan, setiap satu ada {b}": "{a} groups of {b}",
  "{m} markah, {d} minit": "{m} marks, {d} minutes",
  "{n} hari selepas jualan": "{n} days after the sale",
  "{n} langkah": "{n} moves",
  "{price} untuk {n} kertas. Lesen anda kekal sama.": "{price} for {n} papers. Your licence stays the same.",
  "Lapor masalah": "Report a problem",
  "Terangkan apa yang berlaku. Halaman semasa dihantar sekali supaya kami boleh semak.": "Describe what happened. The current page is sent along so we can check.",
  "Contoh: Butang muat turun skema tak jalan untuk Sains Tahun 4.": "Example: The answer scheme download button doesn't work for Science Year 4.",
  "Terima kasih! Laporan anda sudah dihantar.": "Thank you! Your report has been sent.",
  "Laporan tidak dapat dihantar. Cuba lagi.": "The report could not be sent. Please try again.",
  "Simpan gambar QR": "Save QR image",
  "Guna telefon? Simpan gambar QR, kemudian buka app bank atau e-wallet → DuitNow QR → pilih gambar dari galeri.": "On a phone? Save the QR image, then open your bank or e-wallet app → DuitNow QR → choose the image from your gallery.",
  "Tadika · 4–6 tahun": "Preschool · ages 4–6",
  "Jom Baca": "Let's Read",
  "8 tahap suku kata: dari a-i-u hingga baca cerita.": "8 syllable levels: from a-i-u to reading stories.",
  "Mula": "Start",
  "Tadika: Jom Baca": "Preschool: Let's Read",
  "Belajar membaca dengan kaedah suku kata, 8 tahap. Untuk umur 4–6 tahun.": "Learn to read Malay with the syllable method, 8 levels. For ages 4–6.",
  "Untuk ibu bapa: duduk bersama anak. Tekan suku kata untuk dengar bunyinya, minta anak sebut semula, kemudian main permainan di setiap tahap.": "For parents: sit with your child. Tap a syllable to hear it, ask your child to say it back, then play the games in each level.",
  "Peranti ini tidak menyokong bunyi. Bacakan suku kata untuk anak.": "This device does not support sound. Read the syllables to your child.",
  "Tahap {n}": "Level {n}",
  "Tahap tidak dijumpai.": "Level not found.",
  "Kembali ke tahap": "Back to level",
  "Suku kata": "Syllables",
  "Permainan dan kuiz": "Games and quizzes",
  "Perkataan": "Words",
  "Baca ayat": "Read sentences",
  "Cerita": "Stories",
  "Baca dan jawab {n} soalan": "Read and answer {n} questions",
  "Jom main": "Let's play",
  "Cantum suku kata": "Join the syllables",
  "Susun suku kata ikut gambar.": "Put the syllables in order to match the picture.",
  "Pilih gambar": "Pick the picture",
  "Baca perkataan, tekan gambar yang betul.": "Read the word, tap the right picture.",
  "Tahap seterusnya": "Next level",
  "tekan untuk dengar": "tap to listen",
  "Dengar ayat": "Listen to the sentence",
  "Pandai! Teruskan membaca.": "Clever! Keep reading.",
  "Dengar": "Listen",
  "Tekan gambar untuk dengar perkataan.": "Tap the picture to hear the word.",
  "Dengar cerita": "Listen to the story",
  "Jawab soalan": "Answer questions",
  "Suara: {name}": "Voice: {name}",
  "Uji suara": "Test voice",
  "Telefon ini tiada suara Bahasa Melayu, jadi bunyi dimatikan supaya sebutan tidak salah.": "This phone has no Malay voice, so sound is turned off to avoid wrong pronunciation.",
  "iPhone/iPad: Settings → Accessibility → Spoken Content → Voices → Malay (atau Indonesian) → muat turun.": "iPhone/iPad: Settings → Accessibility → Spoken Content → Voices → Malay (or Indonesian) → download.",
  "Android: Settings → Bahasa & input → Output teks-ke-pertuturan → Google → Pasang data suara → Bahasa Melayu (atau Indonesia).": "Android: Settings → Language & input → Text-to-speech output → Google → Install voice data → Malay (or Indonesian).",
  "Selepas itu tutup dan buka semula pelayar. Sementara itu, bacakan suku kata untuk anak.": "Then close and reopen the browser. Meanwhile, read the syllables to your child.",
  "Audio sebutan JomCerdik": "JomCerdik pronunciation audio",
  "Kira Gambar": "Count the Pictures",
  "Kira gambar, kemudian tekan jawapan yang betul.": "Count the pictures, then tap the right answer.",
  "Tambah gambar": "Add pictures",
  "Kira gambar": "Count pictures",
  "Tekan gambar untuk mengira: satu, dua, tiga…": "Tap the pictures to count: one, two, three…",
  "Kenal huruf": "Letters",
  "Huruf apa?": "Which letter?",
  "Cari huruf": "Find the letter",
  "Celik Jawi": "Jawi Reading",
  "37 huruf Jawi. Tekan huruf untuk dengar namanya.": "37 Jawi letters. Tap a letter to hear its name.",
  "Huruf apakah ini?": "Which letter is this?",
  "Cari huruf ini:": "Find this letter:",
  "Mewarna": "Colouring",
  "Pilih warna, kemudian tekan bahagian gambar.": "Pick a colour, then tap part of the picture.",
  "Gambar lain": "Other pictures",
  "Undur": "Undo",
  "Padam semua": "Clear all",
  "Simpan gambar": "Save picture",
  "Matematik tadika: kira dan tambah.": "Preschool maths: count and add.",
  "Kenal huruf Jawi dan bunyinya.": "Learn Jawi letters and their sounds.",
  "Pilih warna, tekan gambar.": "Pick a colour, tap the picture.",
  "Permainan Tadika": "Preschool Games",
  "Jom Baca: 8 tahap": "Let's Read: 8 levels",
  "Pentaksiran Tahun 1–3 (PBD) dan set format UASA Tahun 4–6, atau latihan ikut DSKP.": "Year 1–3 classroom assessment (PBD) and Year 4–6 UASA-format sets, or practice aligned with DSKP.",
  "Pentaksiran & UASA": "Assessment & UASA",
  "Tahun 1–3: latihan pentaksiran PBD": "Year 1–3: PBD classroom assessment practice",
  "Tahun 4–6: set format UASA": "Year 4–6: UASA-format sets",
  "Set latihan pentaksiran Tahun 1–3 (PBD)": "Year 1–3 classroom assessment practice sets (PBD)",
  "Tahun 1–3 menggunakan pentaksiran bilik darjah (PBD), bukan format UASA rasmi KPM. Semak kesesuaian soalan sebelum digunakan.": "Years 1–3 use classroom-based assessment (PBD), not the official KPM UASA format. Check that questions are suitable before use.",
  // ── Dunia 3D (peta, dunia tahun, aktiviti, demo) ──
  "KECIL LANGKAHNYA. BESAR DUNIANYA.": "SMALL STEPS. A BIG WORLD.",
  "Belajar jadi": "Learning becomes",
  "satu pengembaraan.": "one adventure.",
  "Enam dunia untuk diteroka. Seribu sebab untuk rasa ingin tahu.": "Six worlds to explore. A thousand reasons to be curious.",
  "Jom teroka": "Let's explore",
  "Latihan UASA": "UASA Practice",
  "PILIH PENGEMBARAAN KAMU": "CHOOSE YOUR ADVENTURE",
  "Hari ini, ke dunia mana?": "Which world today?",
  "JomBelajar sebenar →": "Real JomBelajar →",
  "Sentuhan portal menggerakkan maskot dan kamera sebelum dunia dibuka.": "Touching a portal moves the mascots and camera before the world opens.",
  "Istana Ajaib": "Magic Castle",
  "Langkah pertama, penemuan besar.": "First steps, big discoveries.",
  "Taman Fantasi": "Fantasy Garden",
  "Ilmu berkembang di setiap sudut.": "Knowledge grows in every corner.",
  "Hutan Pengembaraan": "Adventure Forest",
  "Ikuti denai. Temui jawapannya.": "Follow the trail. Find the answers.",
  "Dunia Angkasa": "Space World",
  "Bawa rasa ingin tahu ke orbit.": "Take your curiosity into orbit.",
  "Bandar Ilmu": "Knowledge City",
  "Bina idea, satu demi satu.": "Build ideas, one by one.",
  "Dunia Futuristik": "Futuristic World",
  "Bersedia untuk pengembaraan seterusnya.": "Get ready for the next adventure.",
  "Buku cerita & huruf": "Storybooks & letters",
  "Words & conversations": "Words & conversations",
  "Nombor, bentuk & idea": "Numbers, shapes & ideas",
  "Eksperimen & penemuan": "Experiments & discoveries",
  "Kisah, peta & garis masa": "Stories, maps & timelines",
  "Berapakah 6 + 7?": "What is 6 + 7?",
  "Bahagian tumbuhan manakah menyerap air?": "Which part of a plant absorbs water?",
  "Bilakah Persekutuan Tanah Melayu mencapai kemerdekaan?": "When did the Federation of Malaya gain independence?",
  "Bunga": "Flower",
  "Daun": "Leaf",
  "Akar": "Root",
  "Batang": "Stem",
  "Air": "Water",
  "Cahaya": "Light",
  "Tumbuh": "Grow",
  "Kini": "Now",
  "Dunia tidak ditemui": "World not found",
  "Kembali ke peta": "Back to the map",
  "← Semua dunia": "← All worlds",
  "PENGEMBARAAN TAHUN {n}": "YEAR {n} ADVENTURE",
  "Kandungan tahun ini →": "This year's content →",
  "Mari teroka {name}.": "Let's explore {name}.",
  "Dua cara untuk belajar": "Two ways to learn",
  "Aktiviti dunia ialah simulasi interaktif untuk semakan reka bentuk. Nota, unit dan kemajuan sebenar kekal di JomBelajar dan memerlukan lesen aktif.": "World activities are interactive simulations for design review. Real notes, units and progress stay in JomBelajar and need an active licence.",
  "Jawi Tadika →": "Kindergarten Jawi →",
  "Cuba aliran UASA →": "Try the UASA flow →",
  "Permainan sebenar →": "Real games →",
  "Mencari kandungan tahun ini…": "Finding this year's content…",
  "Kandungan belum dapat dimuat. Gunakan pautan JomBelajar.": "Content could not be loaded yet. Use the JomBelajar link.",
  "Aktiviti tidak tersedia": "Activity not available",
  "← Dunia Tahun {n}": "← Year {n} World",
  "AKTIVITI CONTOH · DATA SIMULASI": "SAMPLE ACTIVITY · SIMULATED DATA",
  "Buka unit sebenar →": "Open the real unit →",
  "PENEMUAN {n}": "DISCOVERY {n}",
  "Cuba apa yang kamu pelajari": "Try what you learned",
  "Sentuh. Susun. Temui.": "Touch. Arrange. Discover.",
  "Sentuh setiap bahagian tumbuhan, kemudian jalankan eksperimen air.": "Touch each part of the plant, then run the water experiment.",
  "Teroka peristiwa pada garis masa mengikut urutan.": "Explore the events on the timeline in order.",
  "Sentuh kad untuk melihat respons maskot dan susunan baharu.": "Touch a card to see the mascots respond and a new arrangement.",
  "{item} — bagus, teruskan meneroka!": "{item} — great, keep exploring!",
  "Teroka lagi →": "Explore more →",
  "Susunan berubah. Mari cuba sekali lagi.": "The arrangement changed. Let's try again.",
  "KUIZ CONTOH": "SAMPLE QUIZ",
  "Betul! Hebat usaha kamu!": "Correct! Great effort!",
  "Belum tepat. Cuba lagi, kami temankan.": "Not quite. Try again, we're with you.",
  "Betul! Kamu berjaya.": "Correct! You did it.",
  "Belum tepat. Cuba pilihan lain.": "Not quite. Try another option.",
  "Nota dan kuiz sebenar dalam JomBelajar →": "Real notes and quizzes in JomBelajar →",
  "SIMULASI REKA BENTUK · TIADA KREDIT DITOLAK": "DESIGN SIMULATION · NO CREDITS DEDUCTED",
  "Meja persediaan UASA": "UASA preparation desk",
  "Tetapan → proses → kertas tersedia → pratonton.": "Settings → process → paper ready → preview.",
  "Jana kertas contoh": "Generate sample paper",
  "Menyediakan kertas contoh… {n}%": "Preparing sample paper… {n}%",
  "SIMULASI · BUKAN KERTAS PEPERIKSAAN RASMI": "SIMULATION · NOT AN OFFICIAL EXAM PAPER",
  "Latihan contoh {subject} Tahun {year}": "Sample {subject} exercise, Year {year}",
  "Nama: _____________________ Tarikh: ______________": "Name: _____________________ Date: ______________",
  "Lihat jawapan": "Show answer",
  "Cetak contoh": "Print sample",
  "Buka penjana UASA sebenar →": "Open the real UASA generator →",
  "Menyusun kertas contoh. Tunggu sehingga pratonton tersedia.": "Preparing the sample paper. Wait until the preview is ready.",
  "Kertas contoh sudah tersedia untuk dipratonton.": "The sample paper is ready to preview.",
  "DASHBOARD CONTOH · SEMUA REKOD DI BAWAH ADALAH SIMULASI": "SAMPLE DASHBOARD · ALL RECORDS BELOW ARE SIMULATED",
  "Usaha dikongsi, ilmu bertambah.": "Effort shared, knowledge grows.",
  "Pembeli awal yang layak boleh mempromosikan lesen baharu melalui referral.": "Eligible early buyers can promote new licences through referrals.",
  "Dashboard contoh": "Sample dashboard",
  "referral": "referral",
  "jualan": "sales",
  "komisen": "commission",
  "Paparan {tab} contoh dibuka.": "Sample {tab} view opened.",
  "Pautan referral contoh": "Sample referral link",
  "CONTOH-KOD-ANDA": "SAMPLE-YOUR-CODE",
  "Ini kod demonstrasi. Pautan sebenar hanya tersedia dalam akaun affiliate yang layak.": "This is a demonstration code. The real link is only available in an eligible affiliate account.",
  "Kod contoh disalin": "Sample code copied",
  "Salin kod contoh": "Copy sample code",
  "Rekod jualan simulasi": "Simulated sales records",
  "Rujukan": "Reference",
  "Dalam tempoh tahanan": "In holding period",
  "Diluluskan — contoh": "Approved — sample",
  "Komisen contoh": "Sample commission",
  "JUALAN CONTOH": "SAMPLE SALES",
  "KOMISEN SETIAP JUALAN*": "COMMISSION PER SALE*",
  "TEMPOH TAHANAN": "HOLDING PERIOD",
  "{n} hari": "{n} days",
  "*Contoh pembeli lesen RM{n}. Peraturan sebenar menggunakan harga lesen dan kelayakan akaun.": "*Example of a buyer at a RM{n} licence. Real rules use the licence price and account eligibility.",
  "Buka dashboard affiliate sebenar →": "Open the real affiliate dashboard →",
  "SEMAKAN ASET & AKSI": "ASSET & ACTION REVIEW",
  "Kenali Aiman dan Aina.": "Meet Aiman and Aina.",
  "Pilih aksi di bawah. Kami akan menghadap kamu selepas meneroka, dan duduk di kerusi bersama meja serta buku apabila membaca atau menulis.": "Choose an action below. We will face you after exploring, and sit on a chair with a desk and book when reading or writing.",
  "Idle / bernafas": "Idle / breathing",
  "Berkelip": "Blink",
  "Berjalan": "Walk",
  "Berlari": "Run",
  "Melambai": "Wave",
  "Menunjuk": "Point",
  "Melompat": "Jump",
  "Duduk & membaca": "Sit & read",
  "Menulis": "Write",
  "Meraikan": "Celebrate",
  "Jawapan betul": "Correct answer",
  "Galakan": "Encouragement",
  "Menoleh": "Look around",
  "Aksi: {name}": "Action: {name}",
  "Peta dunia →": "World map →",
  "Aliran UASA →": "UASA flow →",
  "Dashboard affiliate contoh →": "Sample affiliate dashboard →",
  "Hai! Kami Aiman dan Aina. Jom teroka bersama.": "Hi! We're Aiman and Aina. Let's explore together.",
  "Jom masuk portal Tahun {n}!": "Let's enter the Year {n} portal!",
  "Dunia Tahun {n} dibuka. Pilih kawasan subjek di bawah.": "Year {n} World is open. Choose a subject area below.",
  "Peranti ini tidak dapat memaparkan WebGL. Gunakan pilihan tahun dan semua aktiviti di bawah.": "This device cannot display WebGL. Use the year options and all activities below.",
  "Enjin 3D tidak dapat dimuat. Cuba semula; navigasi biasa masih tersedia.": "The 3D engine could not be loaded. Try again; normal navigation is still available.",
  "Semak pautan, jualan dan komisen dalam akaun kamu.": "Check your links, sales and commission in your account.",
  "Pilih tetapan kertas. Pratonton hanya muncul apabila kertas tersedia.": "Choose the paper settings. A preview only appears once the paper is ready.",
  "Kami temankan. Ikut panduan pada borang di bawah.": "We're with you. Follow the guidance on the form below.",
  "Pilih subjek dan mulakan penemuan baharu.": "Choose a subject and start a new discovery.",
  "Sedikit demi sedikit, kamu pasti boleh!": "Little by little, you can do it!",
  "DUNIA PEMBELAJARAN 3D": "3D LEARNING WORLD",
  "PRATONTON STAGING": "STAGING PREVIEW",
  "Dunia 3D bersama Aiman dan Aina": "3D world with Aiman and Aina",
  "Enam pulau pembelajaran dan dua maskot 3D. Gunakan butang tahun di bawah untuk akses papan kekunci.": "Six learning islands and two 3D mascots. Use the year buttons below for keyboard access.",
  "Menyiapkan dunia dan dua maskot…": "Preparing the world and two mascots…",
  "Cuba semula 3D": "Retry 3D",
  "Pilih dunia": "Choose a world",
  "Sapa maskot": "Greet the mascots",
  "Maskot melambai": "Mascots waving",
  "Hai! Pilih satu portal untuk mula.": "Hi! Choose a portal to begin.",
  "Sambung animasi": "Resume animation",
  "Jeda animasi": "Pause animation",
  "Menuju portal…": "Heading to the portal…",
  "Sentuh portal bercahaya atau pilih dunia di bawah": "Touch a glowing portal or choose a world below",
  "Model {file} tidak dapat dimuat. Cuba semula paparan 3D.": "Model {file} could not be loaded. Retry the 3D view.",
  "Paparan 3D terhenti. Navigasi dan aktiviti masih boleh digunakan. Cuba muat semula paparan.": "The 3D view stopped. Navigation and activities still work. Try reloading the view.",
  "Dunia 1–6": "Worlds 1–6",
  "PRATONTON DUNIA JOMCERDIK · BELAJAR SAMBIL MENEROKA": "JOMCERDIK WORLD PREVIEW · LEARN WHILE EXPLORING",
  "Uji 13 aksi maskot →": "Test the 13 mascot actions →",
  "Pautan lain": "Other links",
  "Tadika": "Kindergarten",
  "Jawi": "Jawi",
  "Kira": "Counting",
  "Harga & pembelian": "Pricing & purchase",
  "Redeem": "Redeem",
  "Kredit": "Credits",
  "Refund": "Refund",
  "Kertas sedang dijana. Tunggu status sebenar sebelum membuka pratonton.": "The paper is being generated. Wait for the real status before opening the preview.",
  "Kertas siap! Buka kertas yang tersedia dalam senarai.": "Paper ready! Open the available paper in the list.",
  "Cuba lagi. Kamu boleh belajar daripada jawapan tadi.": "Try again. You can learn from the answers just now.",
  "Betul! Hebat usaha kamu.": "Correct! Great effort.",
  "Cuba lagi, kamu boleh!": "Try again, you can do it!",
  "Akaun saya": "My account",
  "Aktif": "Active",
  "Belum aktif": "Not active yet",
  "Tetapkan kata laluan": "Set a password",
  "Tukar kata laluan": "Change password",
  "Kata laluan baharu": "New password",
  "Sahkan kata laluan": "Confirm password",
  "Sekurang-kurangnya 8 aksara.": "At least 8 characters.",
  "Kata laluan sekurang-kurangnya 8 aksara.": "The password must be at least 8 characters.",
  "Kata laluan tidak sama.": "The passwords do not match.",
  "Kata laluan disimpan. Lain kali anda boleh log masuk dengan emel dan kata laluan.": "Password saved. Next time you can sign in with your email and password.",
  "Simpan": "Save",
  "Tetapkan kata laluan supaya lain kali anda boleh log masuk tanpa menunggu emel.": "Set a password so next time you can sign in without waiting for an email.",
  "Tetapkan sekarang": "Set it now",
  "Masukkan emel dan kata laluan anda.": "Enter your email and password.",
  "Kami hantar pautan log masuk sekali guna ke emel anda. Guna ini kali pertama atau jika terlupa kata laluan.": "We email you a one-time sign-in link. Use it the first time or if you forgot your password.",
  "Kata laluan": "Password",
  "Kali pertama atau lupa kata laluan? Hantar pautan ke emel": "First time or forgot your password? Email me a link",
  "Log masuk dengan kata laluan": "Sign in with password",
  "Emel atau kata laluan salah. Belum ada kata laluan? Guna pautan emel.": "Wrong email or password. No password yet? Use the email link.",
  "Terlalu banyak cubaan salah. Cuba lagi dalam 15 minit atau guna pautan emel.": "Too many wrong attempts. Try again in 15 minutes or use the email link.",
  "Masukkan emel anda. Kami hantar pautan untuk anda tetapkan kata laluan baharu.": "Enter your email. We'll send a link so you can set a new password.",
  "Hantar pautan tetapan semula": "Send reset link",
  "Lupa kata laluan?": "Forgot your password?",
  "Kali pertama? Hantar pautan ke emel": "First time? Email me a link",
  "Semak emel anda. Klik pautan untuk log masuk, kemudian tetapkan kata laluan baharu. Pautan sah selama 15 minit.": "Check your email. Click the link to sign in, then set a new password. The link is valid for 15 minutes.",
  "Kertas belum lulus semakan kandungan atau tulisan. Kredit anda tidak ditolak.": "The paper did not pass the content or script checks. No paper credit was charged.",
  "Gambar belum berjaya dijana. Kertas belum disiapkan dan kredit anda tidak ditolak.": "The illustrations could not be generated. The paper is incomplete and no paper credit was charged.",
  "Gambar kertas belum dapat dimuat turun. Sila cuba muat turun semula.": "The paper illustrations could not be downloaded. Please try downloading again.",
  "Tahun 1–6": "Year 1–6",
  "Belajar dengan lebih seronok bersama JomCerdik": "Learn with more fun with JomCerdik",
  "Nota, audio, aktiviti, kuiz dan kertas UASA untuk Tadika hingga Tahun 6.": "Notes, audio, activities, quizzes and UASA papers from Tadika to Year 6.",
  "Akses pantas ke modul pembelajaran": "Quick access to learning modules",
  "Kategori Tadika": "Tadika categories",
  "Cari modul, subjek atau kategori…": "Search modules, subjects or categories…",
  "Cari": "Search",
  "Berapa banyak?": "How many?",
  "Apakah huruf pertama?": "What is the first letter?",
  "Pilih warna": "Choose the colour",
  "Pilih bentuk": "Choose the shape",
  "Sentuh": "Touch",
  "Kategori tidak dijumpai.": "Category not found.",
  "Semua kategori": "All categories",
  "Mula latihan": "Start practice",
  "Tekan gambar untuk dengar": "Tap a picture to listen",
  "Kira gambar dan tekan untuk dengar": "Count the pictures and tap to listen",
  "Dengar lagi": "Listen again",
  "Adi, murid tadika": "Adi, a kindergarten pupil",
  "Betul! Bagus!": "Correct! Well done!",
  "Dengar soalan": "Hear the question",
  "Gambar untuk dikira": "Pictures to count",
  "Lihat keputusan": "See results",
  "Tahniah!": "Congratulations!",
  "betul pada cubaan pertama": "correct on the first try",
  "Kategori pembelajaran": "Learning categories",
  "Jana Kertas": "Create paper",
  "Pilih tahun, subjek, format dan topik.": "Choose year, subject, format and topic.",
  "Latihan Dalam Talian": "Online practice",
  "Pratonton, jawab dan semak jawapan terus.": "Preview, answer and check right away.",
  "Kertas Saya": "My papers",
  "Muat turun PDF kertas dan skema.": "Download the paper and answer scheme as PDF.",
  "Keputusan dan Laporan": "Results and report",
  "Markah, bintang dan kertas yang perlu diulang.": "Scores, stars and papers to redo.",
  "UASA lebih mudah, lebih teratur": "UASA made easier and more organised",
  "Bahagian UASA": "UASA sections",
  "Kertas siap boleh dijawab dalam talian di bahagian Latihan Dalam Talian.": "Finished papers can be answered online in Online practice.",
  "Buka latihan": "Open practice",
  "Belum ada kertas siap. Jana kertas dahulu.": "No finished paper yet. Create one first.",
  "Belum ada keputusan. Selesaikan satu latihan dalam talian.": "No results yet. Finish one online practice.",
  "Purata markah": "Average score",
  "{n} latihan diselesaikan": "{n} practices completed",
  "Perlu diulang": "Needs repeating",
  "Lihat semakan": "View review",
  "Latihan dalam talian": "Practise online",
  "Rajah soalan ini ada dalam PDF kertas.": "This question's diagram is in the paper PDF.",
  "Pratonton kertas. {n} soalan objektif boleh dijawab dalam talian; soalan lain ada dalam PDF.": "Paper preview. {n} objective questions can be answered online; the rest are in the PDF.",
  "Jawapan anda": "Your answer",
  "Pilih bahagian badan": "Choose a body part",
  "Bintang": "Stars",
  "Pilih satu bahagian badan untuk bermula.": "Choose a body part to begin.",
  "pada badan Adi.": "on Adi's body.",
  "Kemajuan": "Progress",
  "Baca suku kata dan perkataan.": "Read syllables and words.",
  "Main sambil belajar.": "Learn while playing.",
  "Modul Pembelajaran": "Learning modules",
  "Soalan": "Question",
  "Apakah nama bahagian ini?": "What is the name of this part?",
  "Tekan untuk dengar sebutan": "Tap to hear it",
  "Ulang Audio": "Play again",
  "Belajar · Bermain · Jadi Lebih Bijak": "Learn · Play · Grow Smarter",
  "Hai, Adik!": "Hi, little one!",
  "Teruskan belajar hari ini": "Keep learning today",
  "Kemajuan Pembelajaran": "Learning progress",
  "{a} / {b} modul": "{a} / {b} modules",
  "Bintang Terkumpul": "Stars collected",
  "Kenal huruf besar dan kecil dengan gambar.": "Learn capital and small letters with pictures.",
  "Kira gambar dan pilih nombor yang betul.": "Count the pictures and pick the right number.",
  "Padankan warna dengan benda di sekeliling.": "Match colours with things around us.",
  "Kenal bulat, segi tiga, segi empat dan lain-lain.": "Learn circles, triangles, squares and more.",
  "Sentuh bahagian badan dan dengar namanya.": "Touch a body part and hear its name.",
  "Kenal haiwan dan bunyinya.": "Meet animals and their sounds.",
  "Kenal buah tempatan yang sedap.": "Meet tasty local fruits.",
  "Makanan dan minuman yang kita suka.": "Food and drinks we love.",
  "Kenderaan di darat, laut dan udara.": "Vehicles on land, sea and air.",
  "Kenal matahari, awan, pokok dan alam sekeliling.": "Meet the sun, clouds, trees and nature.",
  "Kenal pekerjaan dan tugas mereka.": "Meet jobs and what people do.",
  "Kenal perasaan: gembira, sedih, marah dan lain-lain.": "Feelings: happy, sad, angry and more.",
  "Tambah profil anak supaya kemajuan setiap anak disimpan dan boleh dipantau.": "Add your children's profiles so each child's progress is saved and can be tracked.",
  "Siapa belajar hari ini?": "Who is learning today?",
  "Urus anak": "Manage children",
  "Anak": "Children",
  "Sudah mencapai had bilangan anak untuk satu akaun.": "You have reached the number of children allowed for one account.",
  "Belum dipilih": "Not chosen yet",
  "Belum mula": "Not started",
  "Log masuk untuk menambah anak dan melihat perkembangan mereka.": "Sign in to add your children and see their progress.",
  "Padam {name}? Sejarah belajarnya disimpan tetapi tidak lagi dipaparkan.": "Remove {name}? The learning history is kept but no longer shown.",
  "Akaun ibu bapa": "Parent account",
  "Anak-anak saya": "My children",
  "Tambah nama anak, pilih maskot, dan lihat perkembangan setiap seorang.": "Add each child's name, pick a mascot and follow everyone's progress.",
  "Perempuan": "Girl",
  "Lelaki": "Boy",
  "{n} nota": "{n} notes",
  "{n} kuiz": "{n} quizzes",
  "Lihat perkembangan": "See progress",
  "Sedang belajar": "Learning now",
  "Pilih": "Choose",
  "Ubah": "Edit",
  "Padam": "Remove",
  "+ Tambah anak": "+ Add a child",
  "Sudah mencapai had {n} anak.": "You have reached the limit of {n} children.",
  "Sila masukkan nama anak.": "Please enter the child's name.",
  "Ubah maklumat anak": "Edit child details",
  "Tambah anak": "Add a child",
  "Nama anak": "Child's name",
  "Pilih maskot": "Pick a mascot",
  "Tahap persekolahan": "School level",
  "Semua anak": "All children",
  "Nota dibaca": "Notes read",
  "Kuiz diambil": "Quizzes taken",
  "Purata markah kuiz": "Average quiz score",
  "Permainan dimain": "Games played",
  "14 hari terakhir": "Last 14 days",
  "Aktiviti belajar 14 hari terakhir": "Learning activity in the last 14 days",
  "Penguasaan mengikut subjek": "Mastery by subject",
  "Belum ada kuiz. Minta {name} cuba kuiz pertama.": "No quizzes yet. Ask {name} to try the first quiz.",
  "Perlu diperbaiki": "Needs work",
  "Cadangan: bantu {name} mengulang kaji {subject} dahulu.": "Suggestion: help {name} revise {subject} first.",
  "Kuiz terkini": "Recent quizzes",
  "Ruang melukis ada dalam PDF kertas.": "Drawing space is in the paper PDF.",
  "Pratonton kertas. {n} soalan boleh dijawab terus dalam talian (pilih A, B, C).": "Paper preview. {n} questions can be answered right here online (pick A, B, C).",
  "{n} bahagian": "{n} parts",
  "Soalan menulis panjang boleh ditaip, tetapi tidak digalakkan. Untuk latihan menulis, jana kertas UASA atau DSKP (PDF) dan jawab di atas kertas.": "Long written questions can be typed, but this is not encouraged. For writing practice, generate a UASA or DSKP paper (PDF) and answer on paper.",
  "Jawapan menulis panjang tidak digalakkan di sini. Lebih baik jana kertas UASA atau DSKP (PDF) untuk latihan bertulis.": "Long written answers are not encouraged here. It is better to generate a UASA or DSKP paper (PDF) for written practice.",
  "Tunjuk jawapan contoh": "Show model answer",
  "Jawapan contoh": "Model answer",
  "Untuk soalan menulis panjang, jana kertas UASA atau DSKP (PDF).": "For long written questions, generate a UASA or DSKP paper (PDF).",
  "Gambar soalan ini ada dalam PDF kertas.": "This question's picture is in the paper PDF.",
  "Menyediakan pilihan jawapan…": "Preparing answer choices…",
  "Bayar dengan FPX / kad": "Pay with FPX / card",
  "Terus ke internet banking anda. Disahkan secara automatik — tak perlu hantar resit.": "Straight to your online banking. Confirmed automatically — no receipt needed.",
  "Bayar sekarang (FPX / kad)": "Pay now (FPX / card)",
  "Menyemak bayaran…": "Checking payment…",
  "Kami sedang mengesahkan bayaran anda dengan Stripe. Halaman ini dikemas kini sendiri — jangan tutup.": "We are confirming your payment with Stripe. This page updates by itself — don't close it.",
  "atau bayar dengan DuitNow QR di bawah": "or pay with DuitNow QR below",
  "Bayar guna DuitNow QR (manual, perlu hantar resit)": "Pay with DuitNow QR (manual, receipt required)",
  "Masukkan emel anda. Kami hantar pautan pengesahan, kemudian anda tetapkan kata laluan dan terus ke pembayaran.": "Enter your email. We send a confirmation link, then you set a password and go straight to payment.",
  "Hantar pautan pengesahan": "Send confirmation link",
  "Semak emel anda dan klik pautan untuk teruskan ke pembayaran. Pautan sah selama 15 minit.": "Check your email and click the link to continue to payment. The link is valid for 15 minutes.",
  "Sudah ada akaun? Log masuk": "Already have an account? Log in",
  "Lesen anda sudah aktif": "Your licence is active",
  "Terima kasih! Semua modul boleh digunakan sekarang.": "Thank you! All modules are ready to use.",
  "Belum nampak lesen? Muat semula halaman ini, atau hubungi kami dengan emel akaun anda.": "Licence not showing yet? Reload this page, or contact us with your account email.",
  "Akaun: {email}": "Account: {email}",
  "Sekurang-kurangnya 8 aksara. Anda guna ini untuk log masuk lain kali.": "At least 8 characters. You use this to log in next time.",
  "Sebentar sahaja.": "Just a moment.",
  "Tambah": "Add",
  "Tolak": "Subtract",
  "Campur": "Mixed",
  "Belon": "Balloons",
  "Eja": "Spell",
  "Padan": "Match",
  "Pecah Belon": "Pop the Balloons",
  "Tekan belon yang ada jawapan betul.": "Tap the balloon with the right answer.",
  "Matematik: tambah dan tolak.": "Maths: add and subtract.",
  "Asingkan Sains": "Sort the Science",
  "Pilih topik, kemudian jawab dengan gambar.": "Pick a topic, then answer with the pictures.",
  "Sains: haiwan, tumbuhan dan pancaindera.": "Science: animals, plants and the senses.",
  "Eja Perkataan": "Spell the Word",
  "Lihat gambar, kemudian susun huruf.": "Look at the picture, then arrange the letters.",
  "Susun huruf untuk eja perkataan.": "Arrange letters to spell the word.",
  "Buka dua kad dan cari pasangan yang sama.": "Open two cards and find the matching pair.",
  "Cari pasangan yang sama.": "Find the matching pairs.",
  "Huruf besar dan kecil": "Big and small letters",
  "Gambar dan perkataan": "Pictures and words",
  "Langkah: {n}": "Moves: {n}",
  "Betul! Pandai!": "Correct! Well done!",
  "Kuiz": "Quiz",
  "Jeda": "Pause",
  "Organ": "Organs",
  "Suhu": "Temperature",
  "Kedudukan": "Position",
  "Satu edaran": "One orbit",
  "Makan lagi": "Eat again",
  "Makan!": "Eat!",
  "Zum keluar": "Zoom out",
  "Pilih makanan": "Choose a food",
  "Perjalanan Makanan": "Food Journey",
  "Sistem Suria": "Solar System",
  "Sistem pencernaan manusia": "The human digestive system",
  "Pilih makanan, kemudian tekan Makan!": "Choose a food, then tap Eat!",
  "Ikut makanan masuk ke dalam badan. Tekan organ untuk zum.": "Follow the food into the body. Tap an organ to zoom in.",
  "Ikut makanan melalui sistem pencernaan. Tekan organ untuk zum.": "Follow food through the digestive system. Tap an organ to zoom in.",
  "Titik hijau ialah asid dalam perut.": "The green dots are acid in the stomach.",
  "Makanan yang tidak diperlukan oleh badan keluar sebagai najis.": "Food the body does not need leaves as waste.",
  "Planet mengelilingi Matahari. Tekan planet untuk zum.": "The planets orbit the Sun. Tap a planet to zoom in.",
  "Planet beredar mengelilingi Matahari. Tekan planet untuk zum.": "Planets orbit the Sun. Tap a planet to zoom in.",
  "Semakin jauh planet dari Matahari, semakin lama masa untuk beredar satu kali.": "The farther a planet is from the Sun, the longer one orbit takes.",
  "Seret untuk putar. Cubit untuk zum.": "Drag to rotate. Pinch to zoom.",
  "Fotosintesis": "Photosynthesis",
  "Beri pokok air, CO₂ dan cahaya matahari. Lihat ia membesar.": "Give the tree water, CO₂ and sunlight. Watch it grow.",
  "Main semula": "Play again",
  "Peranti ini tidak menyokong 3D. Baca penerangan dan cuba kuiz.": "This device does not support 3D. Read the explanation and try the quiz.",
  "Baru": "New",
  "Padan Warna": "Match Colours",
  "Tarik garisan: padankan warna dengan namanya.": "Draw a line: match each colour with its name.",
  "Besar dan Kecil": "Big and Small",
  "Tarik garisan: padankan huruf kecil dengan huruf besar.": "Draw a line: match each small letter with its capital letter.",
  "Padan Binatang": "Match Animals",
  "Tarik garisan: sambung dua bahagian binatang.": "Draw a line: join the two halves of the animal.",
  "Padan Pekerjaan": "Match Jobs",
  "Tarik garisan: padankan gambar dengan nama pekerjaan.": "Draw a line: match each picture with the job name.",
  "Tarik dari kiri ke kanan, atau ketik kiri kemudian kanan.": "Drag from left to right, or tap the left then the right.",
  "Padan Kenderaan": "Match Vehicles",
  "Tarik garisan: padankan gambar dengan nama kenderaan.": "Draw a line: match each picture with the vehicle name.",
  "Padan Buah": "Match Fruits",
  "Tarik garisan: padankan gambar dengan nama buah.": "Draw a line: match each picture with the fruit name.",
  "Space Math": "Space Math",
  "Medan permainan angkasa": "Space game area",
  "Gerakkan kapal, kemudian tekan Tembak pada batu angkasa yang ada jawapan betul. Jika tembak yang salah, batu itu akan hentam kapal!": "Move your ship, then press Tembak (Fire) at the space rock with the right answer. If you shoot a wrong one, that rock will crash into your ship!",
  "Gerakkan kapal dan tembak batu angkasa yang ada jawapan betul. Tahun 1–6.": "Move the ship and shoot the space rock with the right answer. Years 1–6.",
  "Tembak": "Fire",
  "Geser jari pada skrin untuk gerakkan kapal ke bawah batu angkasa yang betul, kemudian tekan Tembak.": "Slide your finger on the screen to move the ship under the right space rock, then press Tembak (Fire).",
  "Kart Kuiz": "Quiz Kart",
  "Pandu kart 3D bersama Harraz atau Hannah. Pilih lorong jawapan betul untuk boost!": "Drive a 3D kart with Harraz or Hannah. Pick the lane with the right answer to get a boost!",
  "Matematik & Sains": "Maths & Science",
  "Pilih pemandu": "Choose your driver",
  "Topik": "Topic",
  "Peranti ini tidak menyokong grafik 3D untuk permainan ini.": "This device does not support the 3D graphics for this game.",
  "Bersedia…": "Get ready…",
  "Tempat": "Place",
  "Medan permainan": "Game area",
  "Sentuh kiri, tengah atau kanan untuk tukar lorong.": "Touch left, middle or right to change lane.",
  "Pandu kart bersama Harraz atau Hannah! Pilih lorong dengan jawapan betul untuk dapat boost. Jawapan salah akan buat kart berpusing.": "Drive a kart with Harraz or Hannah! Pick the lane with the right answer to get a boost. A wrong answer makes the kart spin.",
  "Jawapan": "Answer",
  "TAMAT": "FINISH",
  "Lari Kuiz": "Quiz Run",
  "Lari 3D bersama Harraz atau Hannah. Lari di bawah jawapan betul dan lompat timbunan buku!": "Run in 3D with Harraz or Hannah. Run under the right answer and jump over the book stacks!",
  "Lari bersama Harraz atau Hannah! Lari di bawah papan jawapan yang betul. Lompat atau tukar lorong untuk elak timbunan buku.": "Run with Harraz or Hannah! Run under the board with the right answer. Jump or change lane to dodge the book stacks.",
  "Sentuh kiri, tengah atau kanan untuk tukar lorong. Leret ke atas untuk lompat.": "Touch left, middle or right to change lane. Swipe up to jump.",
  "Lastik Kuiz": "Quiz Slingshot",
  "Lastik bola ke kotak jawapan yang betul bersama Harraz atau Hannah!": "Sling the ball at the box with the right answer, with Harraz or Hannah!",
  "Bantu Harraz atau Hannah melastik! Tarik ke belakang, bidik dan lepaskan untuk pecahkan kotak dengan jawapan betul.": "Help Harraz or Hannah with the slingshot! Pull back, aim and let go to smash the box with the right answer.",
  "Tarik ke belakang, bidik, kemudian lepaskan.": "Pull back, aim, then let go.",
  "Cuba lagi!": "Try again!",
  "Terbang Kuiz": "Quiz Flight",
  "Terbang dengan beg jet melalui gelang jawapan betul bersama Harraz atau Hannah!": "Fly a jetpack through the right-answer rings with Harraz or Hannah!",
  "Terbang dengan beg jet bersama Harraz atau Hannah! Terbang melalui gelang dengan jawapan betul dan kutip bintang.": "Fly a jetpack with Harraz or Hannah! Fly through the ring with the right answer and collect stars.",
  "Sentuh atas, tengah atau bawah untuk naik atau turun.": "Touch the top, middle or bottom to go up or down.",
  "Dino Kejar": "Dino Chase",
  "Jadi Dino dan kejar Harraz dan Hannah di padang pasir! Dengar soalan, lari di bawah jawapan yang betul untuk mendekati mereka. Lompat kaktus dan elak burung.": "Be Dino and chase Harraz and Hannah across the desert! Listen to the question and run under the right answer to get closer. Jump the cacti and dodge the birds.",
  "Sentuh kiri, tengah atau kanan untuk tukar lorong. Leret ke atas untuk lompat kaktus.": "Touch left, middle or right to change lane. Swipe up to jump the cacti.",
  "Jarak": "Distance",
  "Kejar!": "Chase!",
  "Dapat!": "Caught!",
  "Hampir dapat!": "So close!",
  "Jadi Dino 3D dan kejar Harraz dan Hannah. Lari di bawah jawapan betul, lompat kaktus!": "Be a 3D Dino and chase Harraz and Hannah. Run under the right answer and jump the cacti!",
  "BM & BI": "Malay & English",
  "Jetski Kuiz": "Quiz Jetski",
  "Tunggang jetski bersama Harraz atau Hannah di sungai bandar! Lalu gelang jawapan yang betul untuk nitro. Elak pelampung dan bot, lompat kayu balak.": "Ride a jetski with Harraz or Hannah on the city river! Go through the ring with the right answer for nitro. Dodge the buoys and boats, and jump the logs.",
  "Tunggang jetski 3D di sungai bandar. Lalu gelang jawapan betul untuk nitro, elak bot!": "Ride a 3D jetski on the city river. Go through the right-answer ring for nitro and dodge the boats!",
  "Laju": "Speed",
  "km/j": "km/h",
  "Nitro!": "Nitro!",
};
